import { Link } from "react-router-dom";
import globe from "../../../assets/globe.svg";

import "./index.scss";
import { useTranslation } from "react-i18next";

export const OpenToShopersSection = () => {
  const { t } = useTranslation();

  const onClick = () => {
    window.dataLayer.push({
      event: "gaEvent",
      eventCategory: "Button Click",
      eventAction: "Clicked Join community Button",
      eventLabel: "Presentation page",
    });
  };

  return (
    <div className="c-open-to-shoppers-section">
      <div className="c-open-to-shoppers-section__container">
        {t("presentationPage.open")}
      </div>

      <Link
        to="/home-page"
        className="c-open-to-shoppers-section__button"
        onClick={onClick}
      >
        {t("presentationPage.join")}{" "}
      </Link>

      <img
        src={globe}
        className="c-open-to-shoppers-section__globe"
        alt="globe"
      />
    </div>
  );
};
